<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-10">
              <h3 class="mb-0 view-header-buttons">
                {{ establishment.company_name }}
                <base-button
                  v-if="$currentUserCan($permissions.PERM_EDIT_ESTABLISHMENTS)"
                  type="primary"
                  icon
                  size="sm"
                  @click="editEstablishment()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="
                    $currentUserCan($permissions.PERM_EDIT_ESTABLISHMENTS) &&
                    !establishment.active
                  "
                  type="info"
                  icon
                  size="sm"
                  :disabled="loading"
                  @click="activateEstablishment()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-power-off"></i>
                    {{ $t("ESTABLISHMENTS.ACTIVATE") }}
                  </span>
                </base-button>

                <base-button
                  v-if="
                    $currentUserCan($permissions.PERM_EDIT_ESTABLISHMENTS) &&
                    establishment.active
                  "
                  type="warning"
                  icon
                  size="sm"
                  :disabled="loading"
                  @click="openDeactivateModal()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-power-off"></i>
                    {{ $t("ESTABLISHMENTS.DESACTIVATE") }}
                  </span>
                </base-button>

                <base-button
                  v-if="
                    $currentUserCan($permissions.PERM_DELETE_ESTABLISHMENTS)
                  "
                  type="danger"
                  icon
                  size="sm"
                  @click="deleteEstablishment()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="
                    $currentUserCan($permissions.PERM_VIEW_WAREHOUSES) &&
                    establishment.warehouse
                  "
                  type="info"
                  icon
                  size="sm"
                  :title="$t('COMMON.WAREHOUSE')"
                  @click="showWarehouse()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-building"></i>
                  </span>
                </base-button>
                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="
                    () => {
                      printModalOpened = true;
                    }
                  "
                  v-if="
                    $currentUserCan($permissions.PERM_CREATE_WEEKLY_REPORTS) &&
                    establishment.active &&
                    establishment.weekly_reports_enabled !== false
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span class="btn-inner--text">
                    {{ $t("WEEKLY_REPORTS.ADD_WEEKLY_REPORT") }}
                  </span>
                </base-button>
              </h3>
            </div>
            <div class="col-2 text-right">
              <base-button
                @click="goBack()"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
        </template>
        <div>
          <div class="col-12">
            <establishment-inactive-alert :establishment="establishment" />
          </div>
          <div
            class="col-12 justify-content-center justify-content-sm-between flex-wrap"
          >
            <tabs
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="nav-wrapper"
              tabNavClasses="nav nav-pills nav-fill"
              value="global"
            >
              <card shadow>
                <tab-pane title="global" id="1" :active="true">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GLOBAL") }}
                  </span>
                  <establishment-view-global :establishment="establishment" />
                </tab-pane>

                <tab-pane
                  title="cafeterias"
                  id="2"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_CAFETERIAS)"
                >
                  <span slot="title">
                    <i class="ni ni-folder-17" />
                    {{ $t("COMMON.CAFETERIAS") }}
                  </span>
                  <establishment-view-cafeterias
                    :establishment="establishment"
                  />
                </tab-pane>

                <tab-pane
                  title="contacts"
                  id="3"
                  :active="true"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_CONTACTS)"
                >
                  <span slot="title">
                    <i class="ni ni-circle-08" />
                    {{ $t("COMMON.CONTACTS") }}
                  </span>
                  <establishment-view-contacts :establishment="establishment" />
                </tab-pane>

                <tab-pane
                  title="orders"
                  id="4"
                  :active="true"
                  v-if="
                    $currentUserCan($permissions.PERM_VIEW_ANY_SALES_ORDERS)
                  "
                >
                  <span slot="title">
                    <i class="ni ni-bag-17" />
                    {{ $t("COMMON.SALES_ORDERS") }}
                  </span>
                  <establishment-view-sales-orders
                    :establishment="establishment"
                  />
                </tab-pane>

                <tab-pane
                  title="transfers"
                  id="4b"
                  :active="true"
                  v-if="
                    $currentUserCan(
                      $permissions.PERM_VIEW_ANY_ESTABLISHMENT_TRANSFERS
                    )
                  "
                >
                  <span slot="title">
                    <i class="fa fa-exchange-alt" />
                    {{ $t("COMMON.TRANSFERS") }}
                  </span>
                  <establishment-view-transfers
                    :establishment="establishment"
                  />
                </tab-pane>

                <tab-pane
                  title="internal-invoices"
                  id="4c"
                  :active="true"
                  v-if="
                    $currentUserCan(
                      $permissions.PERM_VIEW_ANY_ESTABLISHMENT_INTERNAL_INVOICES
                    )
                  "
                >
                  <span slot="title">
                    <i class="fa fa-file-invoice-dollar" />
                    {{ $t("COMMON.INTERNAL_INVOICES") }}
                  </span>
                  <establishment-view-internal-invoices
                    :establishment="establishment"
                  />
                </tab-pane>

                <tab-pane
                  title="internal-orders"
                  id="4d"
                  :active="true"
                  v-if="
                    $currentUserCan(
                      $permissions.PERM_VIEW_ANY_ESTABLISHMENT_INTERNAL_ORDERS
                    )
                  "
                >
                  <span slot="title">
                    <i class="fa fa-calendar-week" />
                    {{ $t("ESTABLISHMENT_INTERNAL_ORDERS.INTERNAL_ORDERS") }}
                  </span>
                  <establishment-view-internal-orders
                    :establishment="establishment"
                  />
                </tab-pane>

                <tab-pane
                  title="orders"
                  id="5"
                  :active="true"
                  v-if="
                    $currentUserCan($permissions.PERM_VIEW_ANY_PURCHASES_ORDERS)
                  "
                >
                  <span slot="title">
                    <i class="ni ni-bag-17" />
                    {{ $t("COMMON.PURCHASES_ORDERS") }}
                  </span>
                  <establishment-view-purchases-orders
                    :establishment="establishment"
                  />
                </tab-pane>

                <tab-pane
                  v-if="establishment.has_warehouse"
                  title="establishment-products"
                  id="6"
                >
                  <span slot="title">
                    <i class="fa fa-cubes" />
                    {{ $t("COMMON.PRODUCTS") }}
                  </span>
                  <establishment-view-warehouse-products
                    :establishment="establishment"
                  />
                </tab-pane>

                <tab-pane
                  title="isthera-products"
                  id="61"
                  v-if="
                    $currentUserCan(
                      $permissions.PERM_PROVISION_ISTHERA_PRODUCTS
                    )
                  "
                >
                  <span slot="title">
                    <i class="fa fa-cash-register" />
                    {{ $t("ESTABLISHMENTS.ISTHERA_PRODUCTS") }}
                  </span>
                  <establishment-view-isthera-products
                    :establishment="establishment"
                  />
                </tab-pane>

                <tab-pane
                  title="allowed-users"
                  id="7"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_USERS)"
                >
                  <span slot="title">
                    <i class="ni ni-single-02" />
                    {{ $t("COMMON.USERS") }}
                  </span>
                  <allowed-users-view
                    :object="establishment"
                    :objectName="establishment.company_name"
                    :objectStore="'establishments'"
                    @objectUpdated="get"
                  />
                </tab-pane>

                <!-- <tab-pane
                  title="files"
                  id="998"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
                >
                  <span slot="title">
                    <i class="ni ni-folder-17" />
                    {{ $t("COMMON.FILES") }}
                  </span>
                  <list-file-component :object="establishment" />
                </tab-pane> -->
                <tab-pane
                  title="equipments"
                  id="998"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_EQUIPMENTS)"
                >
                  <span slot="title">
                    <i class="ni ni-folder-17" />
                    {{ $t("COMMON.EQUIPMENTS") }}
                  </span>
                  <establishment-view-equipments
                    :establishment="establishment"
                  />
                </tab-pane>

                <tab-pane
                  title="equipment-transfers"
                  id="998b"
                  v-if="
                    $currentUserCan(
                      $permissions.PERM_VIEW_ANY_EQUIPMENT_TRANSFERS
                    )
                  "
                >
                  <span slot="title">
                    <i class="fa fa-dolly" />
                    {{ $t("EQUIPMENT_TRANSFERS.MENU_TITLE") }}
                  </span>
                  <establishment-view-equipment-transfers
                    :establishment="establishment"
                  />
                </tab-pane>

                <tab-pane
                  title="logs"
                  id="999"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
                >
                  <span slot="title">
                    <i class="fa fa-file" />
                    {{ $t("COMMON.LOGS") }}
                  </span>
                  <establishment-view-logs :establishment="establishment" />
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </card>
    </div>
    <establishment-deactivate-modal
      :show="showDeactivateModal"
      :establishment="establishment"
      :loading="loading"
      :pending-summary="pendingSummary"
      :pending-loading="pendingLoading"
      @confirm="deactivateEstablishment()"
      @close="showDeactivateModal = false"
    />
    <modal
      :show.sync="printModalOpened"
      modal-classes="modal-secondary"
      size="xl"
    >
      <div>
        <h2>{{ $t("WEEKLY_REPORTS.ADD_WEEKLY_REPORT") }}</h2>
        <div>
          <base-input
            :label="`${$t('CASH_REGISTER_READINGS.STARTS_AT')} (*)`"
            :placeholder="$t('CASH_REGISTER_READINGS.STARTS_AT')"
          >
            <flat-picker
              :config="{
                allowInput: true,
                allowInput: true,
                enableTime: false,
                dateFormat: 'Y-m-d',

                locale: $flatPickrLocale(),
              }"
              class="form-control datepicker"
              v-model="weeklyReport.starts_at"
              @on-change="
                () => {
                  onFormChanged();
                }
              "
            >
            </flat-picker>
          </base-input>
          <validation-error :errors="apiValidationErrors.starts_at" />
          <base-input
            :label="`${$t('CASH_REGISTER_READINGS.ENDS_AT')} (*)`"
            :placeholder="$t('CASH_REGISTER_READINGS.ENDS_AT')"
          >
            <flat-picker
              :config="{
                allowInput: true,
                enableTime: false,
                dateFormat: 'Y-m-d',

                locale: $flatPickrLocale(),
              }"
              class="form-control datepicker"
              v-model="weeklyReport.ends_at"
              @on-change="
                () => {
                  onFormChanged();
                }
              "
            >
            </flat-picker>
          </base-input>
          <validation-error :errors="apiValidationErrors.ends_at" />

          <div class="my-4">
            <base-button
              type="button"
              class="btn btn-sm btn-primary"
              native-type="submit"
              @click="handleSubmitweeklyReport()"
            >
              {{ $t("COMMON.SAVE") }}
            </base-button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import { cloneDeep } from "lodash";
import moment from "moment";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
// import ListFileComponent from "@/components/File/ListFileComponent.vue";
import AllowedUsersView from "@/components/AllowedUsers/AllowedUsersView.vue";
import EstablishmentViewGlobal from "./partials/EstablishmentViewGlobal.vue";
import EstablishmentViewSalesOrders from "./partials/EstablishmentViewSalesOrders.vue";
import EstablishmentViewPurchasesOrders from "./partials/EstablishmentViewPurchasesOrders.vue";
import EstablishmentViewLogs from "./partials/EstablishmentViewLogs.vue";
import EstablishmentViewContacts from "./partials/EstablishmentViewContacts.vue";
import EstablishmentViewEquipments from "./partials/EstablishmentViewEquipments.vue";
import EstablishmentViewCafeterias from "./partials/EstablishmentViewCafeterias.vue";
import EstablishmentViewTransfers from "./partials/EstablishmentViewTransfers.vue";
import EstablishmentViewEquipmentTransfers from "./partials/EstablishmentViewEquipmentTransfers.vue";
import EstablishmentViewInternalInvoices from "./partials/EstablishmentViewInternalInvoices.vue";
import EstablishmentViewInternalOrders from "./partials/EstablishmentViewInternalOrders.vue";
import defaultEstablishment from "./defaultEstablishment";
import EstablishmentViewWarehouseProducts from "./partials/EstablishmentViewWarehouseProducts.vue";
import EstablishmentViewIstheraProducts from "./partials/EstablishmentViewIstheraProducts.vue";
import EstablishmentInactiveAlert from "./partials/EstablishmentInactiveAlert.vue";
import EstablishmentDeactivateModal from "./partials/EstablishmentDeactivateModal.vue";
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import flatPicker from "vue-flatpickr-component";
import defaultWeeklyReport from "./defaultWeeklyReport";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    EstablishmentViewGlobal,
    EstablishmentViewSalesOrders,
    EstablishmentViewPurchasesOrders,
    EstablishmentViewLogs,
    EstablishmentViewContacts,
    EstablishmentViewCafeterias,
    EstablishmentViewEquipments,
    EstablishmentViewTransfers,
    EstablishmentViewEquipmentTransfers,
    EstablishmentViewInternalInvoices,
    EstablishmentViewInternalOrders,
    // ListFileComponent,
    AllowedUsersView,
    EstablishmentViewWarehouseProducts,
    EstablishmentViewIstheraProducts,
    EstablishmentInactiveAlert,
    EstablishmentDeactivateModal,
    ValidationError,
    flatPicker,
  },

  mixins: [requestErrorMixin, formMixin],

  data() {
    const defaultWeekly = cloneDeep(defaultWeeklyReport);
    // Préremplit la semaine dimanche → samedi (local, début/fin de journée)
    // afin que le round-trip avec le backend UTC ne décale pas d'un jour.
    const today = moment();
    defaultWeekly.starts_at = today
      .clone()
      .subtract(today.day(), "days")
      .startOf("day")
      .toISOString();
    defaultWeekly.ends_at = today
      .clone()
      .subtract(today.day(), "days")
      .add(6, "days")
      .endOf("day")
      .toISOString();
    return {
      establishment: cloneDeep(defaultEstablishment),
      loading: false,
      printModalOpened: false,
      showDeactivateModal: false,
      pendingSummary: null,
      pendingLoading: false,
      weeklyReport: defaultWeekly,
    };
  },

  created() {
    this.get();
  },

  methods: {
    onFormChanged() {
      this.$emit("formChanged");
    },
    async handleSubmitweeklyReport() {
      this.loading = true;
      const weeklyReportData = {
        ...this.weeklyReport,
        establishment: {
          type: this.establishment.type,
          id: this.establishment.id,
        },
        organization: {
          type: "organizations",
          id: this.establishment.organization.id,
        },
      };

      // Normalise les dates : flatpickr (dateFormat 'Y-m-d') écrit le v-model
      // en chaîne locale sans fuseau ; on les clamp à début/fin de journée
      // en heure locale avant de les convertir en UTC pour éviter tout
      // décalage d'un jour au round-trip avec le backend.
      if (weeklyReportData.starts_at) {
        weeklyReportData.starts_at = moment(weeklyReportData.starts_at)
          .startOf("day")
          .toISOString();
      }
      if (weeklyReportData.ends_at) {
        weeklyReportData.ends_at = moment(weeklyReportData.ends_at)
          .endOf("day")
          .toISOString();
      }

      if (weeklyReportData.serviceCenter) {
        if (!weeklyReportData.serviceCenter.id) {
          delete weeklyReportData.serviceCenter;
        }
      }
      if (weeklyReportData.establishment) {
        if (!weeklyReportData.establishment.id) {
          delete weeklyReportData.establishment;
        }
      }
      if (weeklyReportData.cafeteria) {
        if (!weeklyReportData.cafeteria.id) {
          delete weeklyReportData.cafeteria;
        }
      }

      try {
        await this.$store.dispatch("weeklyReports/add", weeklyReportData);

        this.$notify({
          type: "success",
          message: this.$t("WEEKLY_REPORTS.WEEKLY_REPORT_ADDED"),
        });
        const weeklyReport = await this.$store.getters[
          "weeklyReports/weeklyReport"
        ];
        this.editWeeklyReport(weeklyReport);
        this.loading = false;
        this.printModalOpened = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        const weeklyReport = await this.$store.getters[
          "weeklyReports/weeklyReport"
        ];
        if (weeklyReport.id) {
          await this.$store.dispatch("weeklyReports/destroy", cashRegister.id);
        }
        this.loading = false;
      }
    },

    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("establishments/get", id);
        this.establishment =
          this.$store.getters["establishments/establishment"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    viewWeeklyReport(weeklyReport) {
      this.$router.push({
        name: "View WeeklyReport",
        params: { id: weeklyReport.id },
      });
    },
    async editWeeklyReport(weeklyReport) {
      // this.alertLeave = false;
      this.$router.push({
        name: "Edit WeeklyReport",
        params: { id: weeklyReport.id },
      });
    },
    async editEstablishment(row) {
      this.$router.push({
        name: "Edit Establishment",
        params: { id: this.establishment.id },
      });
    },

    async showWarehouse(row) {
      this.$router.push({
        name: "View Warehouse",
        params: { id: this.establishment.warehouse.id },
      });
    },

    async deleteEstablishment() {
      const confirmation = await swal.fire({
        title: this.$t("ESTABLISHMENTS.DELETE_THIS_ESTABLISHMENT"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch(
            "establishments/destroy",
            this.establishment.id
          );
          await this.goBack();
          this.$notify({
            type: "success",
            message: this.$t("ESTABLISHMENTS.ESTABLISHMENT_DELETED"),
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    goBack() {
      this.$router.push({ name: "List Establishments" });
    },

    async activateEstablishment() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "establishments/activate",
          this.establishment.id
        );
        this.establishment =
          this.$store.getters["establishments/establishment"];
        this.$notify({
          type: "success",
          message: this.$t("ESTABLISHMENTS.ESTABLISHMENT_ACTIVATED"),
        });
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async openDeactivateModal() {
      this.showDeactivateModal = true;
      this.pendingSummary = null;
      this.pendingLoading = true;
      try {
        this.pendingSummary = await this.$store.dispatch(
          "establishments/pendingSummary",
          this.establishment.id
        );
      } catch (error) {
        // Le récapitulatif des éléments en attente est informatif : en cas
        // d'échec on laisse la désactivation possible sans bloquer l'utilisateur.
        this.pendingSummary = null;
      } finally {
        this.pendingLoading = false;
      }
    },

    async deactivateEstablishment() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "establishments/deactivate",
          this.establishment.id
        );
        this.establishment =
          this.$store.getters["establishments/establishment"];
        this.showDeactivateModal = false;
        this.$notify({
          type: "success",
          message: this.$t("ESTABLISHMENTS.ESTABLISHMENT_DEACTIVATED"),
        });
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },
  },
  watch: {
    formErrors(errors) {
      if (errors) {
        this.setApiValidation(errors);
      }
    },
  },
};
</script>
